<template>
  <div class="app-container">
    <div class="filter-container">
      <el-select class="filter-item" v-model="listQuery.querymodel.selftype" @change="getList()" placeholder="选择汇总模式">
        <el-option label="自助缴费分开统计" :value="1"></el-option>
        <el-option label="自助缴费按开单人统计" :value="2"></el-option>
      </el-select>
      <el-select class="filter-item" v-model="listQuery.querymodel.DataType" @change="getList()" placeholder="选择汇总模式">
        <el-option label="按日汇总" :value="1"></el-option>
        <el-option label="按月汇总" :value="2"></el-option>
      </el-select>
      <el-select class="filter-item" v-model="listQuery.querymodel.SectionIds" placeholder="请选择路段" collapse-tags
        :multiple="true" :clearable="true" @change="getList()">
        <el-option v-for="item in sectionlist" :key="item.Id" :label="item.SectionName" :value="item.Id"></el-option>
      </el-select>
      <el-select class="filter-item" v-model="listQuery.querymodel.EmpIds" placeholder="请选择收费员" multiple filterable
        @change="getList()" :clearable="true">
        <el-option v-for="item in emplist" :key="item.Id" :label="item.EmpName" :value="item.Id">
        </el-option>
      </el-select>
      <el-date-picker @change="datechange" class="filter-item" v-model="querydate" type="datetimerange"
        :picker-options="pickerOptions" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间">
      </el-date-picker>
      <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
    </div>
    <el-table class="app-table" :data="list" border fit highlight-current-row stripe ref="orderrecordtable" show-summary
      :summary-method="getSummaries" style="width: 100%" :height="getViewHeight()"
      :header-cell-style="{ background: '#F3F4F7', color: '#555' }" :row-style="{ height: '10px' }"
      :cell-style="{ padding: '7px 0' }">
      <el-table-column type="index" width="50" label="序号"> </el-table-column>
      <el-table-column label="实收统计" :align="center">
        <el-table-column :key="index" v-for="(col, index) in columns.filter((p) => p.GroupId === 1)" :label="col.title"
          :align="col.ColFormat === '1' ? 'right' : 'center'" :prop="col.key" :type="col.type" :width="col.width"
          :formatter="col.ColFormat == '1' ? tableformatter : null">
        </el-table-column>
      </el-table-column>
      <el-table-column label="月卡充值" :align="center">
        <el-table-column :key="index" v-for="(col, index) in columns.filter((p) => p.GroupId === 2)" :label="col.title"
          :align="col.ColFormat === '1' ? 'right' : 'center'" :prop="col.key" :type="col.type" :width="col.width"
          :formatter="col.ColFormat == '1' ? tableformatter : null">
        </el-table-column>
      </el-table-column>
      <el-table-column label="停车收款" :align="center">
        <el-table-column :key="index" v-for="(col, index) in columns.filter((p) => p.GroupId === 3)" :label="col.title"
          :align="col.ColFormat === '1' ? 'right' : 'center'" :prop="col.key" :type="col.type" :width="col.width"
          :formatter="col.ColFormat === '1' ? tableformatter : null">
        </el-table-column>
      </el-table-column>
        <el-table-column label="停车收款款项" :align="center">
        <el-table-column :key="index" v-for="(col, index) in columns.filter((p) => p.GroupId === 4)" :label="col.title"
          :align="col.ColFormat === '1' ? 'right' : 'center'" :prop="col.key" :type="col.type" :width="col.width"
          :formatter="col.ColFormat === '1' ? tableformatter : null">
        </el-table-column>
      </el-table-column>
    </el-table>
    <pagination v-show="total > 0" :total="total" :page.sync="listQuery.pageIndex" :limit.sync="listQuery.pageSize"
      @pagination="getList" />
  </div>
</template>
<script>
import { Getsaledaily, Getsaledailysummary } from "@/api/order";
import { queryemp } from "@/api/employee";
import { MrYangUtil } from "../../utils/time.js";
import { query as querysectionlist } from "@/api/section";
import waves from "@/directive/waves"; // waves directive
import { getButtonList } from "../../promissionRouter";
import Pagination from "@/components/Pagination"; // secondary package based on el-pagination
import Toolbar from "../../components/Toolbar";
export default {
  components: { Pagination, Toolbar },
  directives: { waves },
  data() {
    return {
      dialogshow: false,
      emplist: [],
      buttonList: [],
      downloadLoading: false,
      list: [],
      pageIndex: 1,
      total: 0,
      orderrecordmain: {},
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              end.setHours(23);
              end.setMinutes(59);
              end.setSeconds(59);
              const start = new Date();
              start.setHours(0);
              start.setMinutes(0);
              start.setSeconds(0);
              picker.$emit("pick", [start, end, 1]);
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
              start.setHours(0);
              start.setMinutes(0);
              start.setSeconds(0);
              end.setHours(23);
              end.setMinutes(59);
              end.setSeconds(59);
              picker.$emit("pick", [start, end, 1]);
            },
          },
          {
            text: "本周",
            onClick(picker) {
              let s = MrYangUtil.getCurrentWeek()[0];
              s.setHours(0);
              s.setMinutes(0);
              s.setSeconds(0);
              let e = MrYangUtil.getCurrentWeek()[1];
              e.setHours(23);
              e.setMinutes(59);
              e.setSeconds(59);
              picker.$emit("pick", [s, e, 1]);
            },
          },
          {
            text: "本月",
            onClick(picker) {
              let s = MrYangUtil.getCurrentMonth()[0];
              s.setHours(0);
              s.setMinutes(0);
              s.setSeconds(0);
              let e = MrYangUtil.getCurrentMonth()[1];
              e.setHours(23);
              e.setMinutes(59);
              e.setSeconds(59);
              picker.$emit("pick", [s, e, 1]);
            },
          },
          {
            text: "上月",
            onClick(picker) {
              let s = MrYangUtil.getPreviousMonth()[0];
              s.setHours(0);
              s.setMinutes(0);
              s.setSeconds(0);
              let e = MrYangUtil.getPreviousMonth()[1];
              e.setHours(23);
              e.setMinutes(59);
              e.setSeconds(59);
              picker.$emit("pick", [s, e, 1]);
            },
          },
          {
            text: "本年",
            onClick(picker) {
              let s = MrYangUtil.getCurrentYear()[0];
              s.setHours(0);
              s.setMinutes(0);
              s.setSeconds(0);
              let e = MrYangUtil.getCurrentYear()[1];
              e.setHours(23);
              e.setMinutes(59);
              e.setSeconds(59);
              picker.$emit("pick", [s, e, 1]);
            },
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              start.setHours(0);
              start.setMinutes(0);
              start.setSeconds(0);
              end.setHours(23);
              end.setMinutes(59);
              end.setSeconds(59);
              picker.$emit("pick", [start, end, 1]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              start.setHours(0);
              start.setMinutes(0);
              start.setSeconds(0);
              end.setHours(23);
              end.setMinutes(59);
              end.setSeconds(59);
              picker.$emit("pick", [start, end, 1]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              start.setHours(0);
              start.setMinutes(0);
              start.setSeconds(0);
              end.setHours(23);
              end.setMinutes(59);
              end.setSeconds(59);
              picker.$emit("pick", [start, end, 1]);
            },
          },
        ],
      },
      querydate: "",
      servicetime: 0,
      columns: [],
      listQuery: {
        pageIndex: 1,
        pageSize: 15,
        orderColumn: "",
        orderbyasc: false,
        querymodel: {
          keyword: "",
          EmpIds: [],
          begintime: "",
          endtime: "",
          DataType: 1,
          selftype: 1
        },
      },
    };
  },
  created() {
    try {
      if (window.localStorage.selftype == true || window.localStorage.selftype == "true") {
        this.listQuery.querymodel.selftype = 2;
      }
      let userinfo = JSON.parse(window.localStorage.getItem("user"));
      let stime = userinfo.syspara.filter((it) => it.ParaKey === "ht17")[0]
        .ParaValue;
      let ssstime = new Date(stime);
      let sstime = new Date();
      sstime.setSeconds(0);
      sstime.setHours(ssstime.getHours());
      sstime.setMinutes(ssstime.getMinutes());
      if (sstime.getTime() < new Date().getTime()) {
        this.servicetime =
          sstime.getHours() * 3600 * 1000 + sstime.getMinutes() * 60 * 1000;
      } else {
        this.servicetime = -(
          3600 * 1000 * 24 -
          (sstime.getHours() * 3600 * 1000 + sstime.getMinutes() * 60 * 1000)
        );
      }
    } catch {
      this.servicetime = 0;
    }
    const end = new Date();
    end.setHours(23);
    end.setMinutes(59);
    end.setSeconds(59);
    const start = new Date();
    start.setHours(0);
    start.setMinutes(0);
    start.setSeconds(0);
    start.setTime(start.getTime() + this.servicetime);
    end.setTime(end.getTime() + this.servicetime);
    this.querydate = [start, end];
    this.listQuery.querymodel.begintime = start;
    this.listQuery.querymodel.endtime = end;
    querysectionlist({
      pageSize: 10000,
    }).then((res) => {
      this.sectionlist = res.data;
    });
    queryemp({
      pageIndex: 1,
      pageSize: 10000,
      orderColumn: "",
      orderbyasc: false,
      querymodel: {
        EnableMark: -1,
        ShopMark: -1,
        keyword: "",
        AdminMark: true,
      },
    }).then((res) => {
      this.emplist = res.data;
    });
    this.getList();
  },
  updated() {
    this.$nextTick(() => {
      this.$refs["orderrecordtable"].doLayout();
    });
  },
  methods: {
    tableformatter(row, column, cellValue) {
      return Number(cellValue).toFixed(2);
    },
    getSummaries(param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 1) {
          sums[index] = "总计：";
          return;
        }
        if (this.orderrecordmain[column.property] != undefined) {
          sums[index] = Number(this.orderrecordmain[column.property]).toFixed(
            2
          );
        }
      });
      return sums;
    },
    datechange(item) {
      if (item.length === 3) {
        this.querydate = [item[0], item[1]];
        this.querydate[0].setTime(
          this.querydate[0].getTime() + this.servicetime
        );
        this.querydate[1].setTime(
          this.querydate[1].getTime() + this.servicetime
        );
      }
      this.listQuery.querymodel.begintime = this.querydate[0];
      this.listQuery.querymodel.endtime = this.querydate[1];
      this.getList();
    },
    callFunction(item) {
      this[item.BtnCode].apply(this, item);
    },
    savecomplete(item) {
      this.dialogshow = false;
      this.getList();
    },
    cancelcomplete() {
      this.dialogshow = false;
    },
    getList(item) {
      if (item != null && item != undefined) {
        this.listQuery.pageIndex = item.page;
        this.listQuery.pageSize = item.limit;
      } else {
        this.listQuery.pageIndex = 1;
      }
      Getsaledailysummary(this.listQuery).then((res) => {
        this.orderrecordmain = res;
        Getsaledaily(this.listQuery).then((res) => {
          this.columns = res.columns;
          this.list = res.data;
          this.total = res.dataCount;
        });
      });
    },
    m_export() {
      this.downloadLoading = true;
      import("@/vendor/Export2Excel").then((excel) => {
        const tHeader = [];
        tHeader.push("");
        const filterVal = [];
        let exportcolumns = JSON.parse(JSON.stringify(this.columns));
        exportcolumns.unshift({ title: "序号", key: "index", GroupId: 1 });
        exportcolumns.forEach((item) => {
          if (item.title !== "序号") {
            tHeader.push(item.title);
          }
          filterVal.push(item.key);
        });
        const multiHeader = [[]];
        const merges = ["A1:A2"];
        let length1 = exportcolumns.filter((p) => p.GroupId === 1).length;
        let length2 = exportcolumns.filter((p) => p.GroupId === 2).length;
        let length3 = exportcolumns.filter((p) => p.GroupId === 3).length;
        for (var i = 0; i < exportcolumns.length; i++) {
          multiHeader[0][i] = "";
        }
        multiHeader[0][0] = "序号";
        multiHeader[0][1] = "实收统计";
        let ZM = [
          "A",
          "B",
          "C",
          "D",
          "E",
          "F",
          "G",
          "H",
          "I",
          "J",
          "K",
          "L",
          "M",
          "N",
          "O",
          "P",
          "Q",
          "R",
          "S",
          "T",
          "U",
          "V",
          "W",
          "X",
          "Y",
          "Z",
          "AA",
          "AB",
          "AC",
          "AD",
          "AE",
          "AF",
          "AG",
          "AH",
          "AI",
          "AJ",
          "AK",
          "AL",
          "AM",
          "AN",
          "AO",
          "AP",
          "AQ",
          "AR",
          "AS",
          "AT",
          "AU",
          "AV",
          "AW",
          "AX",
          "AY",
          "AZ",
        ];
        merges.push("B1:" + ZM[length1 - 1] + "1");
        merges.push(ZM[length1] + "1:" + ZM[length1 + length2 - 1] + "1");
        merges.push(
          ZM[length1 + length2] + "1:" + ZM[exportcolumns.length - 1] + "1"
        );
        multiHeader[0][length1] = "会员充值";
        multiHeader[0][length1 + length2] = "消费支付方式";
        multiHeader[0][exportcolumns.length - 1] = "";
        const exportquery = JSON.parse(JSON.stringify(this.listQuery));
        let index = 1;
        exportquery.pageIndex = 1;
        exportquery.pageSize = 1000000;
        Getsaledailysummary(exportquery).then((res) => {
          const orderrecordmain = res;
          orderrecordmain.SaleDate = "总计：";
          Getsaledaily(exportquery).then((res) => {
            res.data.push(orderrecordmain);
            const data = res.data.map((v) =>
              filterVal.map((j) => {
                if (j === "index") {
                  return index++;
                } else {
                  return v[j];
                }
              })
            );
            excel.export_json_to_excel({
              multiHeader,
              header: tHeader,
              merges,
              data,
              filename: "收费员日报",
            });
            this.downloadLoading = false;
          });
        });
      });
    },
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>